import { texts } from "@sveabank/cc-common";
import type { SelectedProduct } from "../../types/product";
import type { Step } from "../../types/step";
import { stepIs } from "../../utils/application";

export const getProductTitle = (productId: string, products: SelectedProduct[]) => {
	const product = products.find((p) => p.productId === productId);
	if (!product) throw new Error("no such product");

	return texts.addons[product.sku].title;
};

export const hasCompletedAmlQuestionsForProduct = (steps: Array<Step>, productId: string) =>
	!!steps
		.find(stepIs("AmlQuestionsStep"))
		?.state.some((s) => s.productId === productId && s.completed);

export const getApplicationQuestionIds = (steps: Array<Step>) =>
	steps.find(stepIs("ApplicationQuestionsStep"))?.state.questions || [];
